export default __webpack_public_path__ + "static/media/filters-icon.be24458b.svg";